import { getCurrentInstance } from 'vue';

const GTM_LIST_BRANCH_SELECTED = 'appointmentReservationListChoosing';
const GTM_MAP_BRANCH_SELECTED = 'appointmentReservationBranchChoosing';
const GTM_NO_TIME = 'appointmentReservationNoTimeSlot';
const GTM_MODAL_CLOSED = 'appointmentReservationClosing';
const GTM_DATE_SELECTED = 'appointmentReservationDateChoosing';
const GTM_SWIPE = 'appointmentReservationDateSwipe';
const GTM_TIME_SELECTED = 'appointmentReservationTimeChoosing';
const GTM_APPOINTMENT_RESERVATION = 'appointmentReservation';
const GTM_SELECT_APPOINTMENT = 'selectAppointment';
const GTM_SEARCH = 'appointmentReservationSearch';
const GTM_ELEMENT_FILLED = 'formElementFilled';

const INTERACTIONS = {
	ONE_STEP_LEFT: 'Már csak 1 lépés!',
	FAILED: 'Nem sikerült időpontot foglalnia!',
	SUCCESS: 'Sikeres időpontfoglalás! - Már csak egy lépés!'
};
export const useGtm = () => {
	const vm = getCurrentInstance().proxy;
	const sendSelectedBranchAddressByPin = () => {
		// no need for it yet
	};
	const sendSelectedBranchAddressByList = () => {
		// no need for it yet
	};
	const sendLeftBlockOpenClose = () => {
		// no need for it yet
	};

	const sendBranchSelected = (address) => {
		vm.$gtm.trackEvent({
			event: GTM_LIST_BRANCH_SELECTED,
			address
		});
	};

	const sendBranchMapSelected = (address) => {
		vm.$gtm.trackEvent({
			event: GTM_MAP_BRANCH_SELECTED,
			address
		});
	};

	const sendNoTime = () => {
		vm.$gtm.trackEvent({
			event: GTM_NO_TIME
		});
	};

	const sendModalClosed = () => {
		vm.$gtm.trackEvent({
			event: GTM_MODAL_CLOSED
		});
	};

	const sendDateSelected = (address, date) => {
		vm.$gtm.trackEvent({
			event: GTM_DATE_SELECTED,
			address,
			date
		});
	};

	const sendSwipe = (address, date, direction) => {
		vm.$gtm.trackEvent({
			event: GTM_SWIPE,
			address,
			date,
			direction
		});
	};

	const sendTimeSelected = (address, partOfDay, time) => {
		vm.$gtm.trackEvent({
			event: GTM_TIME_SELECTED,
			address,
			partOfDay,
			time
		});
	};

	const sendOneStepLeft = () => {
		vm.$gtm.trackEvent({
			event: GTM_APPOINTMENT_RESERVATION,
			interaction: INTERACTIONS.ONE_STEP_LEFT
		});
	};

	const sendReservationFailed = () => {
		vm.$gtm.trackEvent({
			event: GTM_APPOINTMENT_RESERVATION,
			interaction: INTERACTIONS.FAILED
		});
	};

	const sendReservationSuccess = (id) => {
		vm.$gtm.trackEvent({
			event: GTM_APPOINTMENT_RESERVATION,
			interaction: INTERACTIONS.SUCCESS,
			at: id
		});
	};

	const sendSelectAppointment = (address) => {
		vm.$gtm.trackEvent({
			event: GTM_SELECT_APPOINTMENT,
			boxTitle: 'Mikor érkezne?',
			address
		});
	};

	const sendSearch = (term) => {
		vm.$gtm.trackEvent({
			event: GTM_SEARCH,
			term
		});
	};

	const sendElementFilled = (formID, formElementID, inputValue) => {
		vm.$gtm.trackEvent({
			event: GTM_ELEMENT_FILLED,
			formID,
			formElementID,
			inputType: 'text',
			inputValue
		});
	};

	return {
		sendLeftBlockOpenClose,
		sendSelectedBranchAddressByPin,
		sendSelectedBranchAddressByList,
		sendBranchSelected,
		sendBranchMapSelected,
		sendNoTime,
		sendModalClosed,
		sendDateSelected,
		sendSwipe,
		sendTimeSelected,
		sendOneStepLeft,
		sendReservationFailed,
		sendReservationSuccess,
		sendSelectAppointment,
		sendSearch,
		sendElementFilled
	};
};
